import { useWorkspaceSafetyPolicyTemplates } from "@/api/workspace-safety";
import { PolicyListCard } from "@/components/safety-config/PolicyListCard";
import { WorkspaceQuarantineSection } from "./WorkspaceQuarantineSection";

type WorkspacePoliciesTabProps = {
  workspaceId: string;
  onOpenPolicy: (policyId: string) => void;
};

export const WorkspacePoliciesTab = ({ workspaceId, onOpenPolicy }: WorkspacePoliciesTabProps) => {
  const { data: policies } = useWorkspaceSafetyPolicyTemplates(workspaceId);

  // No "Run (30d)" column here: a workspace owns no videos, so a template
  // policy never fires.
  const rows = (policies ?? []).map((policy) => ({
    id: policy.id,
    type: policy.type,
    risksUsing: policy.risksUsing,
    fallbackName: policy.name,
  }));

  return (
    <div className="flex flex-col gap-8">
      <WorkspaceQuarantineSection workspaceId={workspaceId} />
      <PolicyListCard rows={rows} onOpen={onOpenPolicy} />
    </div>
  );
};
